import { render, staticRenderFns } from "./Detail_AP.vue?vue&type=template&id=6e74980c&scoped=true&"
import script from "./Detail_AP.vue?vue&type=script&lang=js&"
export * from "./Detail_AP.vue?vue&type=script&lang=js&"
import style0 from "./Detail_AP.vue?vue&type=style&index=0&id=6e74980c&lang=less&scoped=true&"
import style1 from "./Detail_AP.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e74980c",
  null
  
)

export default component.exports